
import React, { Component, PropTypes } from 'react';
import { UserIsAuthenticated, UserIsVerified } from '../utils/auth';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { pushState } from 'redux-router';
import {
  loadCollageOrganizations,
  openSignupFormRequest,
  openLoginFormRequest
} from '../actions';
import HomeCollage from '../components/HomeCollage';
import AccordionTable from '../components/applyToListLp/AccordionTable';
import TableLayout from '../components/applyToListLp/TableLayout';

class ApplyToListLandingPage extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  openAuthModal = (e) => {
    e.preventDefault()
    this.props.openLoginFormRequest({next: '/apply-to-list'});
  }

  render() {
    const { auth }  = this.props
    let buttonCollage = <Link style={{marginTop: '10px'}} to="/apply-to-list" className="home-collageJoinUs">Apply to list</Link>;

    let browser = this.props.browser;

    let listingOptions = '';
    if (browser.greaterThan.desktop) {
      listingOptions = <TableLayout />
    } else {
      listingOptions = <AccordionTable />
    }

    if (!auth.loggedIn) {
      buttonCollage = <button style={{marginTop: '10px'}} onClick={this.openAuthModal} className="home-collageJoinUs">Apply to list</button>;
    }


    return(
      <main>
        {/* BEGIN content-wrapper */}
        

          <div className="content-wrapper">
            <div className="applyToList-bannerWrapper">
              <div className="applyToList-bannerDesktop">
                <a href="https://youtu.be/ZFlSJZc6fpY?si=FJR8yZMYpIlmnf9y" target="_blank">
                  <img src="images/what_we_do/desktop/whatWeDoBanner_playVideo.png" />
                </a>
              </div>
              <div className="applyToList-bannerMobile">
                <a href="https://youtu.be/ZFlSJZc6fpY?si=FJR8yZMYpIlmnf9y" target="_blank">
                  <img src="images/what_we_do/mobile/whatWeDoBanner_playVideo.png" />
                </a>
              </div>
            </div>

          {/* BEGIN WRAPPER */}
          <div className="applyToListLP-wrapper">

            {/* BEGIN PAGE HEADER */}
            <div className="applyToListLP-header">
              <h2 className="phone">Apply to become an official WWW Member Organization and tap into a powerful global community of women!</h2>

              <h2 className="larger-phone">Apply to become an official WorldWideWomen Member Organization and tap into a powerful global community of women!</h2>
            </div>
            {/* END PAGE HEADER */}

            {/* BEGIN MAIN CONTENT */}
            <div className="applyToListLP-bodyWrapper">

              {/* BEGIN SECTION */}
              <div className="applyToListLP-bodySection">
                <div className="applyToListLP-sectionHead">About</div>
                <p>
                  WorldWideWomen is an easy-to-use online resource platform for women and girls who want trusted information. Our goal is to become the global center where women and girls can come to discover valuable organizations and services like yours. We invite you to join this growing community as an official WorldWideWomen member to build your visibility and expand your base.
                </p>
              </div>
              {/* END SECTION */}

              

              {/* BEGIN SECTION */}
              <div className="applyToListLP-bodySection">
                <div className="applyToListLP-sectionHead">Our reach and demographics</div>
                <div className="applyToListLP-sectionList">
                  <ul className="bulleted">
                    <li className="bulleted">WorldWideWomen members and followers: 100,000+ from 112 countries</li>
                    <li className="bulleted">Newsletter (weekly) database: 30,000; open rate: 30%</li>
                  </ul>
                </div>
              </div>
              {/* END SECTION */}

              {/* BEGIN CHART/MAP SECTION DESKTOP */}
              <div className="applyToListLP-chartMapSectionDesktop">
                <img src="images/apply_to_list_lp/age_gender_data.jpg" />
              </div>
              {/* END CHART/MAP SECTION DESKTOP */}

              

              {/* BEGIN WORLD MAP SECTION DESKTOP */}
              <div className="applyToListLP-worldmap">
                <img src="images/apply_to_list_lp/connect_map3.png" />
              </div>
              {/* BEGIN WORLD MAP SECTION DESKTOP */}

              {/* BEGIN BUTTON */}
              <div className="applyToListLP-button">
                <a className="button button-primary" href="/apply-to-list">Apply here</a>
              </div>
              {/* END BUTTON */}

            </div>
            {/* END MAIN CONTENT */}

            {/* BEGIN SIDEBAR */}
            <div className="applyToListLP-sidebar">


              {/* BEGIN SECTION */}
              <div className="applyToListLP-sidebarSection">
                <div className="applyToListLP-image sidebarImg">
                  <img src="images/apply_to_list_lp/nurse.jpg" />
                </div>

                <div className="applyToListLP-copy">
                  <p>"Oh my, the power of giving women this global information tool is mind-boggling."</p>

                  <p>"I love that this is an 'all in one' spot to connect, inspire and grow as women."</p>

                  <p>"I like the wide networking possibilities. As someone interested in Women empowerment, this site seems like a safe landing page!"</p>
                </div>
              </div>
              {/* END SECTION */}


              {/* BEGIN SECTION */}
              <div style={{ marginTop: '-40px' }}  className="applyToListLP-sidebarSection">
                <div className="applyToListLP-image sidebarImg">
                  <img src="images/apply_to_list_lp/woman_baby.jpg" />
                </div>
                <div className="applyToListLP-copy">
                  <p>"I'm working and I'm also a mother trying to figure out how to marry the two. Having a site like this gives me the opportunity to see what other people have done. Normally, I would just Google, but it comes from all over the place. If there is a site that has vetted information then I can just explore my options."</p>
                </div>


              </div>
              {/* END SECTION */}

              

              

            </div>
            {/* END SIDEBAR */}

          </div>
          {/* END WRAPPER */}

        </div>
        {/* END content-wrapper */}
      </main>

    );
  }
}


function mapStateToProps(state) {
  return state;
};




export default connect(
  mapStateToProps,
  {
    pushState,
    loadCollageOrganizations,
    openSignupFormRequest,
    openLoginFormRequest
 })(ApplyToListLandingPage);



// WEBPACK FOOTER //
// ./src/containers/ApplyToListLP.jsx